import clsx from 'clsx';
import { TargetData } from './data';

const TargetCard: React.FC<TargetData> = ({ id, text, title, Card }) => {
  return (
    <div className={clsx('target-card', `target-card_${id + 1}`)}>
      <div className="target-card__background">
        <Card />
      </div>
      <div className="target-card__content">
        <h4 className="target-card__title">{title}</h4>
        <p className="target-card__text">{text}</p>
      </div>
    </div>
  );
};

export default TargetCard;
